import { twMerge } from "tailwind-merge";

export const twMergeClass = (classToMerge: any) => {
  return twMerge(classToMerge);
};
